export var ACCEPT_FILES = {
    "xls/xlsx": [".xls", ".xlsx"],
    "doc/docx": [".doc", ".docx"],
    "img": ["image/*"],
    "txt": [".txt"],
    "json": [".json"],
};
